module.exports = __webpack_public_path__ + "img/productinfo-5.8e0a0cb8.jpg";